export default __webpack_public_path__ + "static/media/ethereum_logo.78442ea8.svg";